import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoLoteService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    findAll (page,limit, order, column, ...param) {
        return this._http.get(`${this._env}/sales/assprodutoprecoprazo/findall.json?page=${page}&limit=${limit}&order=${order}&column=${column}&param=${param}`, this._headers).then(res => {
            
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllByIdProduto (page,limit, order, column, situacao, idproduto, ...param) {
        return this._http.get(`${this._env}/sales/assprodutoprecoprazo/findallbyidproduto.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&idproduto=${idproduto}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    save(assprodutoprecoprazo) {
        return this._http.post(`${this._env}/sales/assprodutoprecoprazo`, assprodutoprecoprazo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id){
        return this._http.get(`${this._env}/sales/assprodutoprecoprazo/${id}.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(assprodutoprecoprazo) {
        return this._http.post(`${this._env}/sales/assprodutoprecoprazo/updatesituacao`, assprodutoprecoprazo, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }
}